<div class="upload-progress-container" [ngClass]="{'has-promotion': hasPromotion}">
    <div class="upload-progress-body">
        <div class="circular-progress-container">
            <div class="logo-safe-container">
                <app-smash-circular-progress [progress]="progress"></app-smash-circular-progress>
                <div class="progress-percent">{{progress | cleanNumber}}
                    <span> %</span>
                </div>
            </div>
        </div>
        <div class="upload-status-container" *ngIf="!displayResult">
            <ng-container *ngIf="uploadStatus === 'Finishing' else progress">
                <div class="upload-status" [innerHtml]="'UPLOADER_TRANSFER_CREATION' | translate | safeHtml">
                </div>
            </ng-container>
            <ng-template #progress>
                <div class="upload-status" [innerHtml]="'UPLOADER_UPLOAD_PROGRESS' | translate | safeHtml">
                </div>
            </ng-template>

            <div class="upload-description">
                <p *ngIf="isRemainingTimeComputing" translate>UPLOADER_PROGRESS_COMPUTE_REMAINING_TIME</p>
                <p *ngIf="isRemainingTimeDisplayable">{{ 'UPLOADER_PROGRESS_COMPUTE_REMAINING_ALMOST' | translate}}
                    {{ remainingTime | amDuration:'seconds' }}</p>
                <p *ngIf="isRemainingSizeDisplayable">
                    {{ totalSizeUploaded | bytes:2 }} {{ 'UPLOADER_PROGRESS_COMPUTE_REMAINING_TIME_OF' | translate }}
                    {{ totalSizeToUpload | bytes:2 }} </p>
                <p class="upload-description-speed" *ngIf="isSpeedComputing" translate>UPLOADER_PROGRESS_COMPUTING_SPEED</p>
                <p class="upload-description-speed" *ngIf="isSpeedDisplayable">({{ speed | bits:2 }}/s)
                </p>
            </div>
        </div>
        <div class="upload-status-container" *ngIf="uploadMode === 'Link'" [@fade]>
            <ng-container *ngIf="displayResult && transferDelayed">
                <div class="upload-status" [innerHtml]="'UPLOADER_DONE_LINK_TITLE_DELAYED' | translate | safeHtml">
                </div>
                <div class="upload-description" translate [innerHtml]="'UPLOADER_DONE_LINK_TEXT_DELAYED' | translate: { delay: delay } | safeHtml">
                </div>
            </ng-container>
            <ng-container *ngIf="displayResult && !transferDelayed">
                <div class="upload-status" [innerHtml]="'UPLOADER_DONE_LINK_TITLE' | translate | safeHtml"></div>
                
                <div *ngIf="!showDiscoverSmash" class="upload-description" translate [innerHtml]="'UPLOADER_DONE_LINK_TEXT_PREMIUM' | translate | safeHtml"></div>
                <div *ngIf="showDiscoverSmash" class="upload-description" translate [innerHtml]="'UPLOADER_DONE_LINK_TEXT' | translate | safeHtml"></div>

                <div class="upload-link" (click)="copyLink()">
                    <div class="input-container">
                        <app-smash-input borderStyle="full" [copyEnabled]="true" readonly="true" type="text" [value]="transfer.transferUrl"
                           ></app-smash-input>
                        <div class="upload-button-copy-link-copied" *ngIf="linkCopied">{{ 'UPLOADER_COPY_LINK_COPIED' |
                            translate }}</div>
                    </div>
                    
                </div>
            </ng-container>
        </div>
        <div class="upload-status-container" *ngIf="uploadMode === 'Email'" [@fade]>
            <ng-container *ngIf="displayResult && transferDelayed">
                <div class="upload-status" [innerHtml]="'UPLOADER_DONE_EMAIL_TITLE_DELAYED' | translate | safeHtml">
                </div>
                <div class="upload-description" translate [innerHtml]="'UPLOADER_DONE_EMAIL_TEXT_DELAYED' | translate: { delay: delay } | safeHtml">
                </div>
            </ng-container>
            <ng-container *ngIf="displayResult && !transferDelayed">
                <div class="upload-status" [innerHtml]="'UPLOADER_DONE_EMAIL_TITLE' | translate | safeHtml"></div>                
                <div *ngIf="!showDiscoverSmash" class="upload-description" translate [innerHtml]="'UPLOADER_DONE_EMAIL_TEXT_PREMIUM' | translate | safeHtml"></div>
                <div *ngIf="showDiscoverSmash" class="upload-description" translate [innerHtml]="'UPLOADER_DONE_EMAIL_TEXT' | translate | safeHtml"></div>
            </ng-container>
        </div>
    </div>
    <div class="upload-footer">
        <div class="upload-footer-wrapper">
            <button class=" btn light" (click)="cancelUpload()" *ngIf="!displayResult && totalSizeToUpload !== totalSizeUploaded">
                {{ 'UPLOADER_SEND_BUTTON_LABEL_CANCEL' | translate }}
            </button>
            <div class="combo" *ngIf="displayResult && !transferDelayed ">
                <ul class="dropdown smash-suggest-list-container" [ngClass]="{ 'menuExpanded' : menuExpanded }">
                    <li class="smash-suggest link" *ngIf="uploadMode === 'Link'">
                        <a [href]="link" target="_blank">{{ 'UPLOADER_SEND_BUTTON_LABEL_SEE_SMASH' | translate }}</a>
                    </li>
                    <li class="smash-suggest" (click)="makeNewSmash()">{{ 'UPLOADER_SEND_BUTTON_LABEL_AGAIN' | translate }}</li>
                    <li class="smash-suggest link" *ngIf="showDiscoverSmash">
                        <a id="link-send-upgrade-to-premium" href="{{ 'UPLOADER_SEND_LINK_PREMIUM' | translate }}" target="_blank">{{
                            'UPLOADER_SEND_BUTTON_LABEL_DISCOVER_SMASH_PREMIUM' | translate }}</a>
                    </li>
                    <li class="smash-suggest link" *ngIf="showMyAccount">
                        <a [routerLink]="['/account/team/' + selectedTeam.id + '/transfers/sent']">{{
                            'UPLOADER_SEND_BUTTON_LABEL_ACCESS_MY_ACCOUNT' | translate }}</a>
                    </li>
                </ul>

                <label class="red" for="">
                    <div (click)="copyLink()" *ngIf="uploadMode === 'Link'">{{ 'UPLOADER_COPY_LINK' | translate }}</div>
                    <a *ngIf="uploadMode !== 'Link'" [href]="link" target="_blank">{{
                        'UPLOADER_SEND_BUTTON_LABEL_SEE_SMASH' | translate }}</a>
                </label>
                <button class="combo-btn red" (click)="expandMenu()">
                    <i class="icon-smash_expand_arrow " [ngClass]="{ 'menuExpanded' : menuExpanded }"></i>
                </button>
            </div>

            <div class="combo" *ngIf="displayResult && transferDelayed">
                <ul class="dropdown smash-suggest-list-container" [ngClass]="{ 'menuExpanded' : menuExpanded }">
                    <li class="smash-suggest" (click)="makeNewSmash()">{{ 'UPLOADER_SEND_BUTTON_LABEL_AGAIN' | translate }}</li>
                </ul>
                <label class="red" for="">
                    <a id="link-send-delayed-upgrade-to-premium" href="{{ 'UPLOADER_SEND_LINK_PREMIUM' | translate }}" target="_blank">{{
                        'UPLOADER_SEND_BUTTON_LABEL_DISCOVER_SMASH_PREMIUM' | translate }}</a>
                </label>
                <button class="combo-btn red" (click)="expandMenu()">
                    <i class="icon-smash_expand_arrow " [ngClass]="{ 'menuExpanded' : menuExpanded }"></i>
                </button>
            </div>

        </div>
    </div>
</div>